// extracted by mini-css-extract-plugin
export default {"removeCell":"RemoveCell_removeCell__rIzAN"};